module.exports = __webpack_public_path__ + "static/img/temp_bg.2917b893.png";